import { render, staticRenderFns } from "./GalleryTeaserList.vue?vue&type=template&id=49caac8f&scoped=true&"
import script from "./GalleryTeaserList.vue?vue&type=script&lang=js&"
export * from "./GalleryTeaserList.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTeaserList.vue?vue&type=style&index=0&id=49caac8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49caac8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49caac8f')) {
      api.createRecord('49caac8f', component.options)
    } else {
      api.reload('49caac8f', component.options)
    }
    module.hot.accept("./GalleryTeaserList.vue?vue&type=template&id=49caac8f&scoped=true&", function () {
      api.rerender('49caac8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/gallery/GalleryTeaserList.vue"
export default component.exports